export * from './projeto.component';
export * from './list/projetoList.component';
export * from './create/projetoCreate.component';
export * from './edit/projetoEdit.component';
export * from './detail/projetoDetail.component';
export * from './search/projetoSearch.component';
export * from './tab/tab.component';
export * from './projeto.service';